// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.432 21a.568.568 0 01-.567-.568V4.865a.73.73 0 00-.73-.73H3.568a.568.568 0 110-1.135h15.567A1.865 1.865 0 0121 4.865v15.567a.568.568 0 01-.568.568z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;